import api from './api.service';

type ApiBody<T> = { success?: boolean; data?: T; message?: string };

async function unwrap<T>(promise: Promise<unknown>): Promise<T> {
  const body = (await promise) as ApiBody<T>;
  if (body?.data === undefined) throw new Error(body?.message || 'System status request failed');
  return body.data;
}

export type OverallStatus = 'healthy' | 'unhealthy';

export type SystemStatusLive = {
  status: OverallStatus;
  timestamp: string;
  uptime: number;
  environment: string;
  version: string;
  database: 'connected' | 'disconnected';
  database_ok: boolean;
  latency_ms: number | null;
  memory?: {
    rss: number;
    heapTotal: number;
    heapUsed: number;
    external: number;
  };
};

export type DailyHistoryRow = {
  day: string;
  probes: number;
  healthy: number;
  unhealthy: number;
  uptime_pct: number | null;
  status: 'healthy' | 'degraded' | 'unhealthy' | 'unknown';
};

export type RecentProbeRow = {
  id: string;
  checked_at: string;
  overall_status: OverallStatus;
  database_ok: boolean;
  latency_ms: number | null;
  uptime_seconds: number | null;
  build_version: string | null;
  environment: string | null;
};

export type SystemStatusPayload = {
  live: SystemStatusLive;
  summary: {
    uptime_pct_30d: number | null;
    uptime_pct_90d: number | null;
    last_outage_at: string | null;
    probe_days: number;
  };
  history: DailyHistoryRow[];
  recent_probes: RecentProbeRow[];
  probe?: RecentProbeRow;
};

export const systemStatusService = {
  getStatus: () => unwrap<SystemStatusPayload>(api.get('/platform/system-status')),
  recordProbe: () => unwrap<SystemStatusPayload>(api.post('/platform/system-status/probe', {})),
};

export default systemStatusService;
